import React, { useState, useEffect } from "react";
import { Col, Row, Accordion, Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getUserEcosystemDetails } from "../actions/userActions";
import Loader from "./Loader.js";
import axios from "axios";
import lottie from "lottie-web";
import { LinkContainer } from "react-router-bootstrap";
import Reload from "../lottie-files/Reload";
import PlusLoT from "../lottie-files/PlusLoT";
import ToolTip from "./ToolTip";
import UserValidator from "./UserValidator";

function EcosystemDash() {
  const dispatch = useDispatch();
  const ecosystemDetails = useSelector((state) => state.userEcosystemDetails);
  const { loading, error, ecosystem } = ecosystemDetails;

  const [ecosystemName, setEcosystemName] = useState("");
  const [ecosystemType, setEcosystemType] = useState("");
  const [profileReset, setProfileReset] = useState(false);
  const [reportErrorMessage, setReportErrorMessage] = useState(false);
  const [show, setShow] = useState(false);

  const { userInfo } = useSelector((state) => state.userLogin);
  const { role } = userInfo;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function handleReportSubmit(e) {
    e.preventDefault();
    const lastHealthCheck = new Date().toDateString();

    // Get number to work out percentages with
    const scoreDenominator = ecosystem.incubators.length * 100;

    const cohortSize = ecosystem.incubators.length;

    // Lists to store metrics for smes
    const allIncubatorInternalList = [];
    const allIncubatorExternalList = [];
    const allIncubatorRegulatoryList = [];
    const allIncubatorOverallHealthList = [];

    // Populate the lists
    // eslint-disable-next-line
    ecosystem.incubators.map((incubator) => {
      allIncubatorInternalList.push(incubator.internalOperations);
      allIncubatorExternalList.push(incubator.externalOperations);
      allIncubatorRegulatoryList.push(incubator.regulatoryCompliance);
    });

    // Sum up values from the lists ([12, 14, 40] / 300 ) * 100

    const incubatorInternalSum = allIncubatorInternalList.reduce(
      (a, b) => a + b,
      0
    );
    const incubatorExternalSum = allIncubatorExternalList.reduce(
      (a, b) => a + b,
      0
    );
    const incubatorRegulatorySum = allIncubatorRegulatoryList.reduce(
      (a, b) => a + b,
      0
    );
    const incubatorMetricObject = {};

    // Work out the aggregates for each set of metrics (Internal)
    const allIncubatorOverallInternal = Math.round(
      (incubatorInternalSum / scoreDenominator) * 100
    );
    const ecosystemOverallInternal = allIncubatorOverallInternal;

    // Work out the aggregates for each set of metrics (External)
    const allIncubatorOverallExternal = Math.round(
      (incubatorExternalSum / scoreDenominator) * 100
    );
    const ecosystemOverallExternal = allIncubatorOverallExternal;

    // Work out the aggregates for each set of metrics (Regulatory)
    const allIncubatorOverallRegulatory = Math.round(
      (incubatorRegulatorySum / scoreDenominator) * 100
    );
    const ecosystemOverallRegulatory = allIncubatorOverallRegulatory;

    // Build a list to sum the aggregates
    allIncubatorOverallHealthList.push(
      allIncubatorOverallInternal,
      allIncubatorOverallExternal,
      allIncubatorOverallRegulatory
    );

    // Sum the aggregates
    const incubatorOverallSum = allIncubatorOverallHealthList.reduce(
      (a, b) => a + b,
      0
    );

    // Aggregate the sum
    const allIncubatorOverallHealth = Math.round(
      (incubatorOverallSum / 300) * 100
    );
    const ecosystemOverallHealth = allIncubatorOverallHealth;

    //
    incubatorMetricObject.internal = allIncubatorOverallInternal;
    incubatorMetricObject.external = allIncubatorOverallExternal;
    incubatorMetricObject.regulatory = allIncubatorOverallRegulatory;

    const allIncubatorBestMetric = Object.entries(incubatorMetricObject).reduce(
      (max, entry) => (entry[1] >= max[1] ? entry : max),
      [0, -Infinity]
    );
    const allIncubatorWorstMetric = Object.entries(
      incubatorMetricObject
    ).reduce(
      (min, entry) => (entry[1] <= min[1] ? entry : min),
      [0, +Infinity]
    );
    const ecosystemWorstMetric = allIncubatorWorstMetric;
    const ecosystemBestMetric = allIncubatorBestMetric;
    const ecosystemName = ecosystem?.name;
    const companyId = ecosystem?.id;
    const doctype_id = "LAC_V1.5 - Lacoona Ecosystem Report";
    const company_id = userInfo.email;
    const userId = userInfo.id;

    /*  console.log("allIncubatorOverallInternal", allIncubatorOverallInternal);
    console.log("allIncubatorOverallExternal", allIncubatorOverallExternal);
    console.log("allIncubatorOverallRegulatory", allIncubatorOverallRegulatory);
    console.log("allIncubatorOverallHealth", allIncubatorOverallHealth);
    console.log("allIncubatorBestMetric", allIncubatorBestMetric);
    console.log("allIncubatorWorstMetric", allIncubatorWorstMetric);
    console.log("ecosystemOverallInternal", ecosystemOverallInternal);
    console.log("ecosystemOverallExternal", ecosystemOverallExternal);
    console.log("ecosystemOverallRegulatory", ecosystemOverallRegulatory);
    console.log("ecosystemOverallHealth", ecosystemOverallHealth);
    console.log("ecosystemWorstMetric", ecosystemWorstMetric);
    console.log("ecosystemBestMetric", ecosystemBestMetric);
    console.log("ecosystemName", ecosystemName); */

    const apiKey = "TDNMSwa7U1p56gg6gEnH";
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: "Bearer " + apiKey,
      },
    };

    const updateIncubatorConfig = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    axios
      .post(
        "https://api.pdfmonkey.io/api/v1/documents/",
        {
          document: {
            document_template_id: "548A4829-E07D-4CBB-9EBA-285CC0A0BC4E",
            payload: {
              companyId: companyId,
              company_id: company_id,
              doctype_id: doctype_id,
              role: role,
              userId: userId,
              allIncubatorOverallInternal: allIncubatorOverallInternal,
              allIncubatorOverallExternal: allIncubatorOverallExternal,
              allIncubatorOverallRegulatory: allIncubatorOverallRegulatory,
              allIncubatorOverallHealth: allIncubatorOverallHealth,
              allIncubatorBestMetric: allIncubatorBestMetric,
              allIncubatorWorstMetric: allIncubatorWorstMetric,
              ecosystemOverallInternal: ecosystemOverallInternal,
              ecosystemOverallExternal: ecosystemOverallExternal,
              ecosystemOverallRegulatory: ecosystemOverallRegulatory,
              ecosystemOverallHealth: ecosystemOverallHealth,
              ecosystemWorstMetric: ecosystemWorstMetric,
              ecosystemBestMetric: ecosystemBestMetric,
              ecosystemName: ecosystemName,
              cohortSize: cohortSize,
            },
            status: "pending",
          },
        },
        config
      )
      .then(function (response) {
        console.log("Response Received");
      })
      .catch(function (error) {
        console.log("Error Occured");
      });

    axios
      .put(
        "/api/users/update-ecosystem-health/",
        {
          ecosystemOverallInternal: ecosystemOverallInternal,
          ecosystemOverallExternal: ecosystemOverallExternal,
          ecosystemOverallRegulatory: ecosystemOverallRegulatory,
          ecosystemOverallHealth: ecosystemOverallHealth,
          lastHealthCheck: lastHealthCheck,
        },
        updateIncubatorConfig
      )
      .then(function (response) {
        console.log("Response Received");
      })
      .catch(function (error) {
        console.log("Error Occured");
      });
  }

  const config = {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${userInfo?.token}`,
    },
  };

  const submitHandler = (e) => {
    e.preventDefault();
    axios
      .put(
        "/api/users/update-ecosystem/",
        {
          id: ecosystem.id,
          name: ecosystemName,
          type: ecosystemType,
        },
        config
      )
      .then(function (response) {
        console.log("Response Received");
        setProfileReset((oldProfile) => !oldProfile);
      })
      .catch(function (error) {
        console.log("Error Occurred");
      });
  };

  useEffect(() => {
    dispatch(getUserEcosystemDetails());
  }, [profileReset, dispatch]);

  useEffect(() => {
    if (ecosystem) {
      setEcosystemName(ecosystem.name);
      setEcosystemType(ecosystem.type);
    }
  }, [ecosystem]);
  // setEcosystemName(ecosystem?.name);
  // setEcosystemType(ecosystem?.type);

  return (
    <>
      {userInfo?.profile === 3 ? (
        <Col className="dashboard-scrollable-container" lg={9}>
          <Row className="dashboard-content-container">
            <Row className="dashboard-content-divider"></Row>
            {loading ? (
              <Col className="loader">
                <Loader />
              </Col>
            ) : error ? (
              { error }
            ) : (
              <Col className="px-5 py-5">
                {/* Reece Alt Dashboard UI */}
                {/* Title */}
                <Row>
                  <h2 className="ll-subtitle ll-feat-font pt-5">Dashboard</h2>
                </Row>
                {/* Body Content */}
                <Row className="ll-dash-body-content">
                  <Row className="ll-dash-top-content">
                    <Col className="ll-dash-metrics-parent">
                      {/* Conditional start your journey */}
                      <div>
                        {/* Alt UI Featured metric Card */}
                        <Row
                          className="ll-featured-metric-card ll-card-interact"
                          onMouseEnter={() => lottie.play("update-lh")}
                          onMouseLeave={() => lottie.stop("update-lh")}
                        >
                          <Row className="ll-featured-metric-card-top-info">
                            <Modal show={show} onHide={handleClose}>
                              <Modal.Header closeButton>
                                <Modal.Title>Report Generated</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                Please check your documents tab in a few minutes
                                for a copy of your report
                              </Modal.Body>
                              <Modal.Footer>
                                <button
                                  className="lcn-button-orange"
                                  onClick={handleClose}
                                >
                                  Close
                                </button>
                              </Modal.Footer>
                            </Modal>

                            <Col>
                              <h4 className="ll-feature-card-subtext">
                                Overall Ecosystem health
                              </h4>
                            </Col>
                            <Col className="d-flex justify-content-end ll-no-margin px-0 mx-0">
                              <Reload aniName="update-lh" />
                            </Col>
                          </Row>
                          <Row className="ll-featured-metric-card-bottom-info">
                            <Col className="align-content-end">
                              <Row className="align-text-bottom">
                                <Col className="ll-featured-card-metric-number ll-feat-font">
                                  {ecosystem?.legalHealth
                                    ? ecosystem?.legalHealth
                                    : "0"}
                                  <span className="ll-featured-card-metric-percent ll-feat-font">
                                    %
                                  </span>
                                </Col>
                              </Row>
                            </Col>
                            <Col className="ll-metric-card-date">
                              <h4 className="ll-featured-card-metric-last-checked ll-feature-card-subtext">
                                Last checked
                              </h4>
                              <h4 className="ll-featured-card-metric-date ll-feature-card-subtext">
                                {ecosystem?.lastHealthCheck}
                              </h4>
                            </Col>
                          </Row>
                        </Row>
                        {/* AltUI Metric Card - Number of Incubators */}
                        <Row className="ll-metric-card-container">
                          <Row
                            className="ll-metric-card ll-card-interact"
                            onMouseEnter={() => lottie.play("info-rc")}
                            onMouseLeave={() => lottie.stop("info-rc")}
                          >
                            <Col className="">
                              <h5 className="ll-no-margin ll-metric-card-text">
                                Supported
                                <br />
                                Incubators
                              </h5>
                            </Col>
                            <Col className="d-flex flex-column w-100 justify-content-center ll-align-items-end">
                              <div className="text-center justify-content-center">
                                <span className="ll-feat-font ll-metric-general">
                                  {ecosystem?.incubators?.length}
                                </span>
                                {/* <span className="ll-feat-font ll-metric-percentage-general">
                                  %
                                </span> */}
                              </div>
                            </Col>
                            <Col className="d-flex flex-column ll-align-items-end">
                              <ToolTip
                                tooltip="Request an additional incubator to be added"
                                id="tooltip-reg-comp"
                                placement="right"
                              >
                                <a href="mailto:kobus@lacoona.io,jack@lacoona.io?subject=A%20Ecosystem%20has%20requested%20an%20Incubator%20addition&body=Hi%20there%20LacoonaLegal%20Support%2C%0D%0A%0D%0AWe%20would%20like%20to%20support%20an%20Incubator%20on%20your%20system.%0D%0A">
                                  <PlusLoT aniName="info-rc" />
                                </a>
                              </ToolTip>
                            </Col>
                          </Row>
                          <Row align="center">
                            <a
                              target="_blank"
                              href=" https://calendar.app.google/kTSB68MCUHjHSiVU7"
                            >
                              <button className="lcn-button-brown">
                                Schedule a call with us
                              </button>
                            </a>
                          </Row>
                        </Row>
                      </div>

                      {/* Quick Links */}
                      <Row className="ll-dash-quick-links-parent py-4 ll-no-margin">
                        <Row align="center">
                          <h4 className="serious-font">Incubator Overview</h4>
                        </Row>
                        <Row>
                          {ecosystem?.incubators?.length > 0 ? (
                            ecosystem.incubators?.map((incubator, key) => (
                              <div key={key}>
                                <h4>{incubator?.name}</h4>
                                <Accordion>
                                  {incubator?.smes?.map((sme, index) => (
                                    <Accordion.Item
                                      eventKey={sme}
                                      key={index}
                                      id="accordion-item"
                                    >
                                      <Accordion.Header className="py-1">
                                        <Col className="col-5">{sme.name}</Col>
                                        <Col className="col-5">
                                          Legal Health: {sme.legalHealth}
                                        </Col>
                                        <Col>
                                          <ToolTip
                                            tooltip="Nudge this SME to improve their legal health score"
                                            id="tooltip-reg-comp"
                                            placement="right"
                                          >
                                            <i className="fa-solid fa-bell bell-icon"></i>
                                          </ToolTip>
                                        </Col>
                                      </Accordion.Header>
                                      <Accordion.Body className="accordion-body">
                                        <div>
                                          External Operations:{" "}
                                          {sme.externalOperations}
                                        </div>
                                        <div>
                                          Internal Operations:{" "}
                                          {sme.internalOperations}
                                        </div>
                                        <div>
                                          Regulatory Compliance:{" "}
                                          {sme.regulatoryCompliance}
                                        </div>
                                      </Accordion.Body>
                                    </Accordion.Item>
                                  ))}
                                </Accordion>
                              </div>
                            ))
                          ) : (
                            <Row align="center">
                              You currently aren't supporting any incubators
                            </Row>
                          )}
                        </Row>
                      </Row>
                    </Col>

                    {/* Company details section */}
                    <Col className="ll-dash-company-details p-2 px-4">
                      <Row>
                        <h3 className="ll-feat-font">Ecosystem Information</h3>
                      </Row>
                      <Row className="py-4">
                        <Col>
                          <div>
                            <h5>{ecosystem?.name}</h5>
                          </div>
                          <div className="ll-grey-colour ">
                            <h5 className="ll-font-wt-light">Company Name</h5>
                          </div>
                        </Col>
                        <Col>
                          <div>
                            <h5>{ecosystem?.type}</h5>
                          </div>
                          <div className="ll-grey-colour ">
                            <h5 className="ll-font-wt-light">
                              Organisation Type
                            </h5>
                          </div>
                        </Col>
                      </Row>

                      <Row className="generate-reports-container mt-3 px-2">
                        {ecosystem?.incubators?.length > 0 ? (
                          <button
                            className="lcn-button-orange px-3 py-2 mx-3"
                            id="generate-reports"
                            onClick={(e) => {
                              handleReportSubmit(e);
                              handleShow();
                            }}
                          >
                            Generate report
                          </button>
                        ) : (
                          <button
                            className="lcn-button-orange px-3 py-2 mx-3"
                            id="generate-reports"
                            onClick={() => setReportErrorMessage((old) => !old)}
                          >
                            Generate report
                          </button>
                        )}
                        {reportErrorMessage && (
                          <div className="mt-1">
                            To generate a health check report, you first need to
                            be supporting a few Incubators
                          </div>
                        )}
                      </Row>
                      <Row className="py-4">
                        <Accordion>
                          <Accordion.Item eventKey="0">
                            <Accordion.Header>
                              Update Ecosystem Details
                            </Accordion.Header>
                            <Accordion.Body>
                              <Form onSubmit={submitHandler}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="ecosystemName"
                                >
                                  <Form.Label>Ecosystem Name</Form.Label>
                                  <Form.Control
                                    type="input"
                                    // placeholder="Enter Ecosystem name"
                                    value={ecosystemName ? ecosystemName : ""}
                                    onChange={(e) =>
                                      setEcosystemName(e.target.value)
                                    }
                                  />
                                </Form.Group>
                                <Form.Group
                                  className="mb-3"
                                  controlId="ecosystemType"
                                >
                                  <Form.Label>Ecosystem Type</Form.Label>
                                  <Form.Select
                                    aria-label="Default select example"
                                    onChange={(e) =>
                                      setEcosystemType(e.target.value)
                                    }
                                  >
                                    <option value="Venture">Venture</option>
                                    <option value="Institutional">
                                      Institutional
                                    </option>
                                    <option value="Merge & Acquire">
                                      Merge & Acquire
                                    </option>
                                  </Form.Select>
                                </Form.Group>
                                <Row>
                                  <Col align="end">
                                    <button
                                      className="lcn-button-brown px-5 py-3"
                                      type="submit"
                                    >
                                      Update
                                    </button>
                                  </Col>
                                </Row>
                              </Form>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </Row>
                      <Row>
                        <LinkContainer to={"/dashboard/profile"}>
                          <button className="lcn-button-brown">
                            Update user details
                          </button>
                        </LinkContainer>
                      </Row>

                      <Row>
                        <Col className="ll-dash-activity-details"></Col>
                      </Row>
                    </Col>
                  </Row>
                  {/* More Content Space for later */}
                  <Row className="ll-dash-bottom-content"></Row>
                </Row>
                {/* End of Reece Attempt */}
              </Col>
            )}
          </Row>
        </Col>
      ) : (
        <Col className="dashboard-scrollable-container">
          <Row className="dashboard-content-container">
            <Col align="center" className="mt-5 pt-5">
              <h3>Unfortunately this page is only available to Incubators</h3>
            </Col>
          </Row>
        </Col>
      )}
      {!userInfo ? (
        <UserValidator />
      ) : (
        userInfo?.profile === 0 && <UserValidator />
      )}
    </>
  );

  // return (
  //   <Col className="dashboard-scrollable-container" lg={9}>
  //     <Row className="dashboard-header-container py-3">
  //       <h3 className="dashboard-header">SME Dashboard</h3>
  //     </Row>

  //     <Row className="dashboard-content-container">
  //       <Row className="dashboard-content-divider"></Row>
  //       <h3>Sorry, you are not authorized to view this page </h3>
  //     </Row>
  //   </Col>
  // );
}

export default EcosystemDash;
